import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getArvoreEquips } from '../../slices/arvoreSlice';
import { Chip, Option, Select, Typography } from '@material-tailwind/react';
import TableArvore from '../../components/Table/TableArvore';

const ArvoreInfo = () => {
  const { tag, name } = useParams();
  const dispatch = useDispatch();
  const { arvoreEquip, loading } = useSelector((state) => state.arvore);
  const [selected, setSelected] = useState('');

  useEffect(() => {
    if (name != '-') {
      dispatch(getArvoreEquips(tag));
    }
    setSelected('');
  }, [tag]);

  return (
    <div className="w-[100%] max-h-[80dvh] sm:h-full overflow-auto sm:overflow-hidden  min-h-96 rounded-md bg-transparent dark:bg-darkColorBox p-5 border-b border-t border-yellow-600 sm:border-none ">
      <div className="flex flex-col sm:flex sm:flex-row justify-between  uppercase text-red-500 sm:text-black sm:dark:text-white items-center">
        <Typography variant="h3" className="p-2 w-full text-base text-white">
          {name}
        </Typography>
        <Chip value={tag} className="dark:bg-white dark:text-black mb-2" />
      </div>
      <div className="relative block h-10 mb-2">
        {!loading && (
          <>
            {!selected && (
              <span className="absolute left-0 top-0 text-black  bg-gray-400  inline-block w-full rounded-md p-2">
                Selecione o equipamento
              </span>
            )}
            <Select
              value={selected}
              onChange={(value) => setSelected(value)}
              className={`text-black border-white dark:border-transparent uppercase ${
                selected && ' bg-gray-400'
              }`}
              labelProps={{ className: 'hidden' }}
            >
              {arvoreEquip.length > 0 ? (
                arvoreEquip.map((item) => (
                  <Option
                    key={item.id}
                    value={`${item.id}`}
                    className="text-black items-center space-x-2 font-bold uppercase"
                  >
                    {item.nome} - <span className="font-normal text-xs uppercase">{item.tag}</span>
                  </Option>
                ))
              ) : (
                <Option disabled className="text-black">
                  Nenhum equipamento
                </Option>
              )}
            </Select>
          </>
        )}
      </div>

      <div className="overflow-auto h-[99%]  global-scrollbar">
        <TableArvore idGet={selected}></TableArvore>
      </div>
    </div>
  );
};

export default ArvoreInfo;
